"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RoRo API
 * This documents RoRo APIs for handling public facing App needs
 *
 * The version of the OpenAPI document: 0.0.43
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function OrderDetailFromJSON(json) {
    return OrderDetailFromJSONTyped(json, false);
}
exports.OrderDetailFromJSON = OrderDetailFromJSON;
function OrderDetailFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'purchaseType': !runtime_1.exists(json, 'purchaseType') ? undefined : json['purchaseType'],
        'purchaseChannel': !runtime_1.exists(json, 'purchaseChannel') ? undefined : json['purchaseChannel'],
        'orderData': !runtime_1.exists(json, 'orderData') ? undefined : (json['orderData'] === null ? null : new Date(json['orderData'])),
        'paid': !runtime_1.exists(json, 'paid') ? undefined : json['paid'],
        'priceDetails': !runtime_1.exists(json, 'priceDetails') ? undefined : (json['priceDetails'].map(_1.CostDetailFromJSON)),
        'discountDetails': !runtime_1.exists(json, 'discountDetails') ? undefined : (json['discountDetails'].map(_1.CostDetailFromJSON)),
        'totalPrice': !runtime_1.exists(json, 'totalPrice') ? undefined : json['totalPrice'],
        'title': !runtime_1.exists(json, 'title') ? undefined : json['title'],
        'rideDetail': !runtime_1.exists(json, 'rideDetail') ? undefined : _1.BriefRideDetailFromJSON(json['rideDetail']),
        'planDetail': !runtime_1.exists(json, 'planDetail') ? undefined : _1.PlanDetailFromJSON(json['planDetail']),
        'paymentGatewayId': !runtime_1.exists(json, 'paymentGatewayId') ? undefined : json['paymentGatewayId'],
    };
}
exports.OrderDetailFromJSONTyped = OrderDetailFromJSONTyped;
function OrderDetailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'purchaseType': value.purchaseType,
        'purchaseChannel': value.purchaseChannel,
        'orderData': value.orderData === undefined ? undefined : (value.orderData === null ? null : value.orderData.toISOString()),
        'paid': value.paid,
        'priceDetails': value.priceDetails === undefined ? undefined : (value.priceDetails.map(_1.CostDetailToJSON)),
        'discountDetails': value.discountDetails === undefined ? undefined : (value.discountDetails.map(_1.CostDetailToJSON)),
        'totalPrice': value.totalPrice,
        'title': value.title,
        'rideDetail': _1.BriefRideDetailToJSON(value.rideDetail),
        'planDetail': _1.PlanDetailToJSON(value.planDetail),
        'paymentGatewayId': value.paymentGatewayId,
    };
}
exports.OrderDetailToJSON = OrderDetailToJSON;
